
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>


<div *ngIf="entity">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" href="/files/shares-ledger/entity/{{ entity.id }}/{{ entity.version }}">
          <t-icon name="file_download"></t-icon>
          <span class="text">Télécharger</span>
        </a>
        
        <a class="btn" (click)="cancel()">
          <t-icon name="close"></t-icon>
          <span class="text">Annuler</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="form-group">
    <t-checkbox label="Afficher les lignes masquées" [(checked)]="showHidden"></t-checkbox>
  </div>

  <sl-entity-movements-ledger *ngIf="entity" [entity]="entity" [showHidden]="showHidden"></sl-entity-movements-ledger>
</div>